<template>
    <div class="shop-checkin-container">
        <!-- 步骤指引区域 -->
        <div class="steps-container">
            <!-- 第一步 -->
            <div class="step-section">
                <div class="step-title">
                    <span class="step-number">第一步</span>
                    <div class="step-content">
                        客户进入【我的】个人中心，点击打开二维码
                    </div>
                </div>

                <!-- 二维码示例图片 -->
                <div class="qrcode-example">
                    <img :src="checkinImg" alt="二维码示例" />
                </div>
            </div>

            <!-- 第二步 -->
            <div class="step-section">
                <div class="step-title">
                    <span class="step-number">第二步</span>
                    <div class="step-content">
                        点击下方按钮，扫描码客户二维码后，完成所有门店活动签到
                    </div>
                </div>
            </div>
        </div>

        <!-- 扫码按钮 -->
        <div class="scan-button-container">
            <button class="scan-button" @click="startScan">去扫码</button>
        </div>
    </div>
</template>

<script setup>
import { showToast } from "vant";
import authApi from "@/utils/api/auth";
import { useRouter } from "vue-router";
import bar1 from "@/assets/img/checkin_tip.png";
import * as ww from '@wecom/jssdk'
const router = useRouter();
const checkinImg = bar1;

async function initWeWorkConfig() {
    ww.register({
        corpId: import.meta.env.VITE_WECOM_CORPID,       // 必填
        agentId: import.meta.env.VITE_WECOM_AGENTID,                  // 必填，当前应用的 AgentID
        jsApiList: ['scanQRCode'], // 必填
        // 获取“企业签名”的回调
        getConfigSignature: async (url) => {
            // 这里的 url 是 SDK 自动传，不要手动用 window.location.href
            const res = await authApi.getsignature(url);
            return {
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
            };
        },

        // 获取“应用签名”的回调（跳转小程序必须有这个）
        getAgentConfigSignature: async (url) => {
            const res = await authApi.getAgentSignature(url);
            return {
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
            };
        },
    });
}
onMounted(() => {
    initWeWorkConfig();
})
// 打开二维码扫描
const startScan = () => {
    ww.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function (res) {
            console.log('scanQRCode success', res)
            handleScanResult(res.resultStr);
        },
        fail: function (res) {
            if (res.errMsg.indexOf('function_not_exist') > 0) {
                showToast({
                    message: '版本过低请升级',
                })
            }
            console.log('scanQRCode fail', res)
        }
    })
}

// 处理扫码结果
const handleScanResult = (resultStr) => {
    try {
        // 解析扫描结果
        console.log("处理扫描结果:", resultStr);
        router.push({
            path: "/selActivity",
            query: {
                resultStr: resultStr,
            },
        });

        // 这里可以添加对扫描结果的处理逻辑
        // 例如：调用后端API进行签到验证

        // 模拟签到成功
        setTimeout(() => {
            alert("签到成功！");
        }, 500);
    } catch (error) {
        console.error("处理扫描结果时出错:", error);
        showToast("解析二维码信息失败，请扫描正确的二维码");
    }
};
</script>

<style lang="less" scoped>
.shop-checkin-container {
    padding: 10px 17px;
    min-height: 100vh;

    // 步骤容器样式
    .steps-container {
        padding: 0 10px 10px 10px;
        background-color: #fff;
        border-radius: 8px;

        .step-section {
            padding: 0;
            margin: 0;

            .step-title {
                margin-bottom: 15px;

                .step-number {
                    display: inline-flex;
                    align-items: center;
                    font-size: 15px;
                    color: #333333;
                    font-weight: 500;
                    margin-right: 8px;

                    &::before {
                        content: "";
                        display: inline-block;
                        width: 3px;
                        border-radius: 2px;
                        height: 14px;
                        background-color: #ff7123;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                }

                .step-content {
                    font-size: 15px;
                    color: #333333;
                }
            }

            .qrcode-example {
                width: 100%;
                border-radius: 8px;
                padding: 0 5px;

                img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 4px;
                }
            }
        }
    }

    // 扫码按钮样式
    .scan-button-container {
        .scan-button {
            width: 100%;
            height: 46px;
            background-color: #dcbb89;
            color: #ffffff;
            border: none;
            border-radius: 11px;
            font-size: 19px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s;

            &:active {
                background-color: #c8a77c;
            }
        }
    }
}
</style>
